module.exports = __webpack_public_path__ + "img/octagon-xmark.f81c5fc1.svg";